import * as React from 'react'
import { useTranslation } from 'react-i18next'
import Margin from 'components/Margin'
import { Label, Paragraph, Heading } from 'components/primitives'
import { DynamoEvents } from 'types/events'

export const DispatchAllStateRideInfo = ({ event }: { event: DynamoEvents }) => {
  const { serviceLocations, rideAlongLocation } = event.attributes
  const luggageCount = event.attributes.luggageCount?.value
  const passengerCount = event.attributes.passengerCount?.value
  const pickupLocation = serviceLocations.callerLocation
  const dropoffLocation = serviceLocations.callerDestinationLocation
  const { t } = useTranslation()

  if (!rideAlongLocation) return null

  return (
    <>
      <Heading as="h4">{event.attributes.rideAlong ? t('universal.rideAlong') : t('universal.stm')}</Heading>
      {passengerCount != null && (
        <Margin spacing="sm">
          <Label>{t('case.passengerCount')}</Label>
          <Paragraph spacing="sm">{passengerCount}</Paragraph>
        </Margin>
      )}
      {luggageCount != null && (
        <Margin spacing="sm">
          <Label>{t('case.luggageCount')}</Label>
          <Paragraph spacing="sm">{luggageCount}</Paragraph>
        </Margin>
      )}
      {pickupLocation && <PickupLocation pickupLocation={pickupLocation} />}
      {dropoffLocation && <DropoffLocation dropoffLocation={dropoffLocation} />}
    </>
  )
}

const PickupLocation = ({
  pickupLocation,
}: {
  pickupLocation: { addressDescription: string; latitude: string; longitude: string }
}) => {
  const { t } = useTranslation()
  return (
    <Margin spacing="sm">
      <Label>{t('case.pickupLocation')}</Label>
      <Paragraph spacing="sm" style={{ whiteSpace: 'pre-line' }}>
        {pickupLocation.addressDescription.replace(/<br\s*\/?>/gi, '\n')}
      </Paragraph>
      <Label>{t('case.coordinates')}</Label>
      <Paragraph spacing="sm">{`${pickupLocation.latitude}, ${pickupLocation.longitude}`}</Paragraph>
    </Margin>
  )
}
const DropoffLocation = ({ dropoffLocation }: { dropoffLocation: { addressDescription: string; name: string } }) => {
  const { t } = useTranslation()
  return (
    <Margin spacing="sm">
      <Label>{t('case.dropoffLocation')}</Label>
      <Paragraph spacing="sm" style={{ whiteSpace: 'pre-line' }}>
        {dropoffLocation.addressDescription.replace(/<br\s*\/?>/gi, '\n')}
      </Paragraph>
    </Margin>
  )
}

export default DispatchAllStateRideInfo
